import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { AiReceptionistConfig, AiReceptionistProfile } from '../../models/AiReceptionist';

interface UpdateCompanyAiReceptionistDetailPayload {
  company_id: string;
  subscription_id: string;
  profile: AiReceptionistProfile;
  config: AiReceptionistConfig;
}

export interface AiReceptionistDetailUpdateResponse {
  profile: Omit<AiReceptionistProfile, 'is_provisioned'>;
  config: AiReceptionistConfig;
}

export async function updateCompanyAiReceptionistDetail(
  payload: UpdateCompanyAiReceptionistDetailPayload,
  auth: Authentication,
): Promise<AiReceptionistDetailUpdateResponse> {
  try {
    if (!payload.company_id || !payload.subscription_id) {
      throw new UpdateCompanyAiReceptionistDetailFailure('company_id et subscription_id sont requis');
    }

    const response = await HttpClient.put('/company/ai-receptionist/detail', payload, auth.token);

    return response.data as AiReceptionistDetailUpdateResponse;
  } catch (e) {
    console.error('updateCompanyAiReceptionistDetail error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new UpdateCompanyAiReceptionistDetailFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new UpdateCompanyAiReceptionistDetailFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class UpdateCompanyAiReceptionistDetailFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
